// extracted by mini-css-extract-plugin
export var body = "_dd-5";
export var closeButton = "_dd-f";
export var container = "_dd-1";
export var content = "_dd-2";
export var cta = "_dd-c";
export var ctaLabel = "_dd-b";
export var eyebrow = "_dd-3";
export var howTo = "_dd-6";
export var image = "_dd-e";
export var modal = "_dd-0";
export var socialButton = "_dd-d";
export var stepCard = "_dd-8";
export var stepLabel = "_dd-a";
export var stepNumber = "_dd-9";
export var steps = "_dd-7";
export var title = "_dd-4";